import styled from "styled-components";


export const Container = styled.div`
    width: ${({ size, width }) => width ? width : size ? size : 100}px;
    height: ${({ size, height }) => height ? height : size ? size : 100}px;
    position: relative;
`;

export const Content = styled.div`
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-color: #88888840;
    border-radius: 10px;
    overflow: hidden;
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
`;

export const Input = styled.input`
`;

export const IconUnSelectWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    
    position: absolute;
    top: -10px;
    right: -10px;

    width: 24px;
    height: 24px;
    
    background-color: #f82323;
    border-radius: 50%;
`;

export const IconWrapper = styled.div`
    padding: 20px;
    width: 100%;
    height: 100%;
`;